<template>
  <v-layout wrap>
    <v-flex v-if="lastOperation">
      <v-progress-circular v-if="operationInProgress"
      :size="20"
      :width="2"
      color="success"
      indeterminate
    ></v-progress-circular>
      <v-icon v-if="lastOperationSuccess" color="success">fas fa-check-circle</v-icon>
      <v-icon v-if="lastOperationFailure" color="error">fas fa-ban</v-icon>
      &nbsp;{{lastOperation}}
      &nbsp;(at {{lastOperationDateTime}})
    </v-flex>
    <v-flex>
      {{lastOperationMessage}}
    </v-flex>
  </v-layout>
</template>
<script>

import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  computed: {
        ...mapGetters('status', {
            operationInProgress: 'operationInProgress',
            lastOperation: 'lastOperation',
            lastOperationSuccess: 'lastOperationSuccess',
            lastOperationFailure: 'lastOperationFailure',
            lastOperationMessage: 'lastOperationMessage',
            lastOperationDateTime: 'lastOperationDateTime'
        })
    },

}
</script>
